/*
 * Copyright (c) 2024-2025 Hardfin, Inc.
 */
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { ticketSchema } from '@/ticket/api/types';
import { z } from 'zod';

const ticketResponseSchema = z.object({
  data: z.array(ticketSchema),
});

export async function getProjectTickets(projectKey: string) {
  const url = `/v1/tickets-for-project/${projectKey}`;
  const response = await api.get(url);

  const data = await parseResponse(ticketResponseSchema, response.data, {
    schemaName: 'ProjectTickets',
    endpoint: url,
  });
  return data.data;
}
